<template>
  <div
    :class="classes"
    role="status"
    aria-busy="true"
  />

</template>

<script lang="ts">
export default { name: 'OSkeleton' }
</script>

<script setup lang="ts">
interface Props {
  shape?: 'rect' | 'rectangle' | 'circle'
  animated?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  shape: 'rect',
  animated: true,
})

const classes = computed(() => {
  return [
    'inline-block',
    'overflow-hidden',
    'bg-gray-200',
    'dark:bg-gray-700',
    props.animated ? 'animate-pulse' : '',
    props.shape === 'circle' ? 'rounded-full' : 'rounded',
  ]
})
</script>
